// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 362 ? "b6715477" : chunkId) + "." + {"362":"ddd4bf21e10e22c1","436":"183ee782de462610"}[chunkId] + ".js";
};